import styled from "styled-components";
import colours from "../../lib/colours";
import { Link } from "../../components/atoms/Link";
import { ExternalLinkIcon } from "../../components/atoms/ExternalLinkIcon";
import {
  firstPartyOffsetPlanTemplate,
  gainScoringManual,
} from "../../lib/constants";

const Container = styled.section`
  padding-bottom: 24px;
`;

const SectionTitle = styled.h4`
  margin-top: 24px;
  margin-bottom: -8px;
  font-weight: 600;
  color: ${colours.th1};
`;

const MediumSpan = styled.span`
  font-weight: 500;
`;

function ReviewDownloadOffset() {
  return (
    <Container>
      <SectionTitle>Next steps</SectionTitle>
      <>
        <p>
          To establish the native vegetation you have mapped as an offset site,
          you need to sign a security agreement. This can be done either with
          your local Council, DEECA or Trust for Nature.
        </p>
        <p>
          It's important to be aware of the costs associated with this process,
          which include administration and monitoring fees, legal costs for
          registering the agreement on title, potential surveying expenses,
          ongoing management expenditures, potential income loss from foregoing
          the use and development of the land, and the associated impact on land
          value.{" "}
          <MediumSpan>
            Before signing the agreement, carefully consider all these costs.
          </MediumSpan>
        </p>
        <p>
          You are required to adhere to the management commitments outlined in
          the first party general offset management plan. You can find a{" "}
          <Link
            href={firstPartyOffsetPlanTemplate}
            target="_blank"
            title="First party general offset site management plan template"
            rel="noopener noreferrer"
          >
            template
          </Link>
          <ExternalLinkIcon /> for the management plan on the DEECA website.
        </p>
        <p>The land management commitments may include:</p>
        <ul>
          <li>Retaining all trees, including standing dead trees.</li>
          <li>Excluding stock and mitigating other potential threats.</li>
          <li>
            Preventing an increase in weed cover beyond the current level.
          </li>
          <li>
            Monitoring and eliminating new and emerging weeds to maintain them
            at less than one percent.
          </li>
          <li>Preserving logs, fallen timber, and organic litter.</li>
          <li>Controlling rabbit populations.</li>
          <li>
            Ensuring Scattered Tree protection by recruiting or planting at
            least five native canopy tree species for each protected tree.
          </li>
          <li>
            Conducting revegetation activities in line with the minimum planting
            standards specified in the{" "}
            <Link
              href={gainScoringManual}
              target="_blank"
              title="Native vegetation gain scoring manual, Version 2"
              rel="noopener noreferrer"
            >
              Native vegetation gain scoring manual, Version 2
            </Link>
            <ExternalLinkIcon />.
          </li>
          <li>Providing annual reports on management actions.</li>
        </ul>
        <p>Here are the next steps:</p>
        <ul>
          <li>Export the mapped data for your future use.</li>
          <li>Download the Native Vegetation Offset Report.</li>
          <li>
            Obtain the{" "}
            <Link
              href={firstPartyOffsetPlanTemplate}
              target="_blank"
              title="First party general offset site management plan template"
              rel="noopener noreferrer"
            >
              first party general offset management plan template
            </Link>
            <ExternalLinkIcon /> from the DEECA website.
          </li>
          <li>
            Schedule a meeting with your local council, DEECA or Trust for
            Nature to discuss establishing the offset site. Discuss the survey
            plan for the native vegetation to be protected during the meeting.
          </li>
        </ul>
        <p>
          By following these steps, you can progress toward establishing the
          offset site and fulfilling your obligations effectively.
        </p>
      </>
    </Container>
  );
}

export default ReviewDownloadOffset;
